import { useMemo } from 'react';

import { useMarketsList } from '@/features/Markets';
import { useAppSelector } from '@/hooks/redux-hooks';

import groupMarketsBySector from '../utils/groupMarketsBySector';

export const useMarketsNavigationItems = () => {
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { data } = useMarketsList(undefined, tripTokenStatus === 'fulfilled');
  const groupedMarkets = data?.groupedMarkets;
  const menuItems = useMemo(() => {
    return groupMarketsBySector(groupedMarkets ?? []);
  }, [groupedMarkets]);

  return { menuItems };
};
